import { Button, EmptyStateIllustration3 } from "ui";

export default function EmptyPlans({ onClickAdd }) {
  return (
    <div className="mt-28 flex flex-col items-center">
      <EmptyStateIllustration3 />

      <span className="mt-6 text-sm font-medium text-foundations-boldest">
        Create your first plan
      </span>
      <span className="mt-1 text-sm font-normal text-foundations-bold">
        Get started by adding a new plan
      </span>
      <div className="mt-6 block">
        <Button onClick={onClickAdd}>Create a plan</Button>
      </div>
    </div>
  );
}
